import { post } from '../ReaderlyHttpClient';
import { LoginResponse } from './UserService/Data';

export interface AccountInvite {
  link: string;
  expiresAt: string;
  emailSent: boolean;
  emailError?: string | null;
}

export interface AccountInviteValidation {
  isValid: boolean;
  name?: string | null;
  lastName?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  expiresAt?: string | null;
}

export interface AccountInviteAcceptRequest {
  token: string;
  email: string;
  phoneNumber?: string;
  newPassword: string;
}

export const createAccountInvite = (userId: number, sendEmail: boolean) => {
  return post<AccountInvite, { sendEmail: boolean }>(`/api/admin/users/${userId}/invite`, { sendEmail }, undefined, {
    suppressGlobalError: true,
  });
};

export const validateAccountInvite = (token: string) => {
  return post<AccountInviteValidation, { token: string }>('/users/invite/validate', { token }, undefined, {
    suppressGlobalError: true,
  });
};

export const acceptAccountInvite = (request: AccountInviteAcceptRequest) => {
  return post<LoginResponse, AccountInviteAcceptRequest>('/users/invite/accept', request, undefined, {
    suppressGlobalError: true,
  });
};
